import React, { useEffect, useState, useRef  } from "react";
import { TextInput, Button, ButtonIcon,Checkbox,AccordionItemV2,Font,Slot, Icon, Notification, Modal,ProgressBar } from "pepsico-ds";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useForm, useWatch } from "react-hook-form";
import forge from "node-forge";
import { useNavigate } from "react-router";
import pepsi_logo from "../assets/Logo.png";
import no_vpn_logo from '../assets/no vpn connection 4.svg';
import vpn_logo from '../assets/vpn connection.svg';
import success_logo from '../assets/change-password-success.svg';
import { useLoading } from "../loader";
import "./auth.css";
import { toast,ToastContainer } from 'react-toastify';
import ForgotFooter from "../common/forgot_footer";
import ErrorFailOverHandler from "../common/error_fail_over_handler";

const publicKey = `-----BEGIN RSA PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsoZnlKyNcmMo3zrdx3KGc+/+fk1Jn7zYVyENg8hf6+SQ+p03Mzx8+hO6QUWgkJtlQfWBabZWMolGcpr37QTs4LJc6IEdvy24b8SjWM8AXj6II+SRpOR1m7W9I0eD16+6/nLWBpB5FAxCjrODC//BZVvGStXnTfQZc+/E2EamK21DneFkJaC9FlTwoNSy+LM5bjf6Q2YjWuX06uePzaAOLnycyhA8fHMoHwBQLdzfpKwRKMOr3VnDilem9RH9zGi44rg8y2g2TY1WzvsStmDM8NduV5aOnwzFMo+BTugfLhdP4ZmYR/BX5WLfPmxkAEI5fVNONBCuzoJsyX424wMLlwIDAQAB
    -----END RSA PUBLIC KEY-----`;
export const encrypt = (plainText, key) => {
  const publicKey = forge.pki.publicKeyFromPem(key);
  return forge.util.encode64(
    publicKey.encrypt(plainText, "RSA-OAEP", {
      md: forge.md.md5.create(),
      mgf1: {
        md: forge.md.sha1.create(),
      },
    })
  );
};

export const encryptAES = async (msg) => {
  const key = crypto.getRandomValues(new Uint8Array(16)); // 128-bit key
  const iv = crypto.getRandomValues(new Uint8Array(12)); // 96-bit IV (recommended for AES-GCM)

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    key,
    { name: "AES-GCM" },
    true,
    ["encrypt"]
  );

  const encodedMsg = new TextEncoder().encode(msg);

  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    encodedMsg
  );

  return {
    key: btoa(String.fromCharCode(...key)), // Convert to Base64 for storage
    iv: btoa(String.fromCharCode(...iv)),
    encrypted: btoa(String.fromCharCode(...new Uint8Array(encrypted))),
  };
};

const ChangePassword = () => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [userName, setUserName] = useState("");
  const [showErrorPage, setShowErrorPage] = useState(false);
  const [gpid, setgpid] = useState("");
  const [powdSuccess, setpowdSuccess] = useState(false);
  const [powdSuccessTime, setpowdSuccessTime] = useState(false);
  const { showLoader, hideLoader } = useLoading();
  const userToken = JSON.parse(localStorage.getItem("okta-token-storage"))
    ?.idToken?.idToken;
  const accessToken = JSON.parse(localStorage.getItem("okta-token-storage"))
    ?.accessToken?.accessToken;
  const userLang = localStorage.getItem("i18nextLng");
  let userGpId = "";
  const { t,i18n } = useTranslation();
  const [gpidErrorMessage, setGpidErrorMessage] = useState("");
  const [type, setType] = useState("password");
  const [reType,setReType] = useState("password");
  const [icon, setIcon] = useState('visibility');
  const [reTypeIcon, setReTypeIcon] = useState('visibility');
  const [isUserValid, setUserValid] = useState(false);
  const history = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [isUpdatePassword, setUpdatePassword] = useState(true);
  const [isBg, setIsBg] = useState(false);
  const [passwordValue, setPasswordValue] = useState("");
  const [showGuidelines, setShowGuidelines] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null);
  const [toasts, setToasts] = useState([]);
  const [updateStatus,setUpdateStatus]=useState(false);
  const [updateStatusNonPepsico,setUpdateStatusNonPepsico] =useState(false);
  const [requestNumber,setRequestNumber] = useState('');
  const [copied, setCopied] = useState(false);
  const [copiedNonPepsi, setCopiedNonPepsi] = useState(false);
  const [buttonName,setButtonName] = useState('Copy');
  
  const totalTime = 10 * 60; // 10 minutes in seconds
  const [transactionId,setTransactionId] = useState(0);
  const [triggerApi,setTriggerApi] = useState(false)
  const [timeLeft, setTimeLeft] = useState(totalTime);
  const [showPassword, setShowPassword] = useState(false);
  const [hasInput,setHasInput] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isIpad,setIsIpad]= useState(false);
  const [validpassword, setValidPassword]= useState(true);
  const [hasPBC,setHasPBC] = useState(false);
  const [hasApiError, setHasApiError] = useState(false);

  useEffect(() => {
     if (!powdSuccess || timeLeft <= 0) return;
     const interval = setInterval(() => {
     setTimeLeft(prev => prev - 1);
     }, 1000);
     return () => clearInterval(interval);
    }, [powdSuccess,timeLeft,i18n.language]);
    
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsIpad(window.innerWidth > 768 && window.innerWidth <= 1024)
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  const showToast = (message, type) => {
    setToasts([
      {
        id: 1,
        duration: 5000,
        text: message,
        type: type,
        position: "bottom-right",
      },
    ]);
  };

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  const closeModal = () => {
    setUpdateStatus(false);
  };
  const updateModalStatus = () => {
    setUpdateStatus(true);
  };
  const closeModalNonPepsico = () => {
    setUpdateStatusNonPepsico(false);
  };
  const updateModalStatusNonPepsico = () => {
    setUpdateStatusNonPepsico(true);
  };

  const goToHomePage = () =>{
    navigate('/home')
  }

  const textToCopy = `${t('changePassword.pepsi_network_text1')}
    ${t('changePassword.pepsi_network_text2')}
    ${t('changePassword.pepsi_network_text3')}`;
  const textToCopyNonPepsi = `${t('changePassword.pepsi_non_network_text1')}
    ${t('changePassword.pepsi_non_network_text2')}`

const copyToClipboard = async (textToCopy,nonPepsi) => {
  try {
    await navigator.clipboard.writeText(textToCopy);
    nonPepsi ? setCopiedNonPepsi(true) : setCopied(true);
    nonPepsi ? setTimeout(() => setCopiedNonPepsi(false), 2000) : setTimeout(() => setCopied(false), 2000);
  } catch (err) {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      console.error("Copy failed", e);
    }
  }
}

  // showToast('You’ll have two passwords until you connect to the PepsiCo network (at a PepsiCo location or via VPN). Use your old password to log into your computer and your new password for PepsiCo systems and applications, Otherwise If connected to pepsico’s wifi or vpn You can use your new password to log in to both your computer and the PepsiCo systems and applications  ')
  const handleChange = (event) => {
    const onlyNumbers = event.target.value.replace(/[^0-9]/g, ""); // Regex to remove non-numeric characters
    setInputValue(onlyNumbers);
    if (event.target.value?.length === 8) {
    }
  };
  const handleToggle = () => {
    if (type === "password") {
      setIcon('visibility_off');
      setType("text");
    } else {
      setIcon('visibility');
      setType("password");
    }
  };
  const handleToggleRetypePassword = () =>{
    if (reType === "password") {
      setReTypeIcon('visibility_off');
      setReType("text");
    } else {
      setReTypeIcon('visibility');
      setReType("password");
    }
  }

  const {
    register,
    handleSubmit,
    control,
    setError,
    clearErrors,
    trigger,
    setValue,
    formState: { errors, isValid },
    watch,
  } = useForm({
    mode: "onChange",
  });

  const password = useWatch({ control, name: "password" });
  const newPassword = useWatch({ control, name: "newPassword" });

  const onConfirmation = (event) => {
    setIsConfirmed(event);
  };

  const updatePassword = (data) => {
    validateUserAndUpdatePassword(data);
  };
  const data = JSON.parse(localStorage.getItem("okta-token-storage"));
  if (!gpid && data?.accessToken?.claims?.gpid) {
    userGpId = data?.accessToken?.claims?.gpid;
  }
  if (!userName && data?.accessToken?.claims?.displayname) {
    setUserName(data?.accessToken?.claims?.displayname);
  }
  useEffect(() => {
    getEndpointAccounts();
    showLoader();
  }, []);
  useEffect(() => {
    if (newPassword && passwordValue !== newPassword) {
      setError("newPassword", {
        type: "manual",
        message: "Passwords do not match",
      });
    } else {
      clearErrors("newPassword");
    }
  }, [password, newPassword, setError, clearErrors]);

  const validateUserAndUpdatePassword = async (data) => {
    setGpidErrorMessage("");
    try {
      showLoader();
      const validateResponse = await axios
        .post(REACT_APP_API_ENDPOINT + "user/validate", {
          gpid: userGpId,
          usertoken: userToken,
          apitoken: accessToken,
        })
      // .then((response) => {
      //   showLoader();
      // });
      if (validateResponse?.data?.status=== "Success") {

        let encryptedPwd = encrypt(data.password, publicKey);
        await axios
          .post(REACT_APP_API_ENDPOINT + "user/changePassword", {
            gpid: userGpId,
            password: encryptedPwd,
            confirmPassword: encryptedPwd,
            termCondition: "true",
          })
          .then((response) => {
            showLoader();
            if (response?.data?.status === "Success") {
              // setpowdSuccess(true);
              // showToast("You’ve successfully changed your password.",'success');
              toast.success("You’ve successfully changed your password.");
              setTransactionId(response?.data?.transactionId);
              setRequestNumber(response.data.requestNumber)
              setUpdatePassword(false);
              // setTriggerApi(true);
              setpowdSuccessTime(true);
              // setTimeout(() => {
              //   setpowdSuccess(true);
              //   setpowdSuccessTime(false);
              // }, 200000);
              // history('/home');
              hideLoader();
            } else if (response.data.status === "Failed") {
              // showToast(response?.data?.errorMessage,'error')
              toast.error(response?.data?.errorMessage);
              setHasInput(false);
              setIsConfirmed(false);
              setHasApiError(true);
              setGpidErrorMessage(response.data.errorMessage);
              hideLoader();
            }
          })
          .catch((error) => {
            // Handle error (e.g., display error message)
            console.error(
              "Error fetching data:",
              error?.response?.data?.message
            );
            if (error?.response?.status === 403 || error?.response?.status === 401 || error?.response?.status === 400 || error?.response?.status === 500 || error?.response?.status === 501) {
              setShowErrorPage(true);
            }
            setHasInput(false);
            setIsConfirmed(false);
            setHasApiError(true);
            // showToast(error?.response?.data?.message, 'error');
            toast.error(error?.response?.data?.message)
            setGpidErrorMessage(error?.response?.data?.message);
            hideLoader();
            return {
              gpid: "xxxxxx",
              secQuestions: [
                "What was your xxxxx?",
                "What was your xxxxxx?",
              ],
              mobile: "xxxxx",
            };
          });
      } else {
        // showToast(validateResponse?.data?.errorMessage,'error');
        toast.error(validateResponse?.data?.errorMessage);
        // setGpidErrorMessage(validateResponse.data.errorMessage);
        setUserValid(false);
        hideLoader();
      }
    } catch (error) {
      hideLoader();
      // showToast(error?.response?.data?.message,'error');
      toast.error(error?.response?.data?.message);
      if (error?.response?.status === 403 || error?.response?.status === 401 || error?.response?.status === 400 || error?.response?.status === 500 || error?.response?.status === 501) {
        setShowErrorPage(true);
      }
      setGpidErrorMessage(
        error?.response?.data?.message || "An error occured!"
      );
    }
  };
// Forbidden keywords
    const forbiddenKeywords = [
      "spring",
      "summer",
      "fall",
      "winter",
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
      "PepsiCo",
      "Pepsi",
    ];
  const powdMessageValidation = (powd) => {
    setIsTyped(true);
    setPasswordValue(powd);
    powd ? setShowGuidelines(true) : setShowGuidelines(false);
    powd ? setHasInput(true) : setHasInput(false);
    setHasApiError(false);
    setGpidErrorMessage('');
    if (newPassword && powd !== newPassword) {
      setError("newPassword", {
        type: "manual",
        message: "Passwords do not match",
      });
    } else {
      clearErrors("newPassword");
    }
    // Clear the previous timer
    if (typingTimer) clearTimeout(typingTimer);

    // Set a new timer
    // const timer = setTimeout(() => {
    //   setShowGuidelines(false);
    //   clearTimeout(timer);
    // }, 15000);

    // setTypingTimer(timer);
    // Base regex for MUST conditions
    const minLength = powd.length >= 12;
    const maxLength = powd.length <= 24;
    const hasTwoNumbers = (powd.match(/\d/g) || []).length >= 2;
    const hasFourLetters = (powd.match(/[a-zA-Z]/g) || []).length >= 4;
    const noSpecialChars = /^[a-zA-Z0-9]*$/.test(powd);

    // Check length, letters, numbers, and special characters
    const isBaseValid = minLength;

    // Additional checks
    const hasLowercase = /[a-z]/.test(powd);
    const hasUppercase = /[A-Z]/.test(powd);
    const hasSpecialChar = /[!^*()_|~`{}.#\[\]:;'"<>?,]/.test(powd);
    // const hasTwoNumbers = /\d.*\d/.test(powd);

    
    // const noForbiddenKeywords = !forbiddenKeywords.some((keyword) =>
    //   powd.toLowerCase().includes(keyword.toLowerCase())
    // );
    const noForbiddenKeywords = !(forbiddenKeywords ?? [])
      .map(k => String(k ?? "").trim().toLowerCase())
      .filter(Boolean)
      .some(k => powd.toLowerCase().includes(k));

    // Sequential characters check (abc, 123)
    const isSequential = (str) => {
      for (let i = 0; i < str.length - 2; i++) {
        if (
          str.charCodeAt(i + 1) === str.charCodeAt(i) + 1 &&
          str.charCodeAt(i + 2) === str.charCodeAt(i) + 2
        ) {
          return true;
        }
      }
      return false;
    };
    const noSequentialChars = !isSequential(powd);

    // Repeating characters check (no more than two repeating characters)
    const noRepeatingChars = !/(.)\1{2,}/i.test(powd);

    // Check if it starts or ends with a number
    const notStartWithNumber = !/^\d/.test(powd);
    const notEndWithNumber = !/\d$/.test(powd);

    // Update validation state
    setPowdHints({
      minLength: isBaseValid,
      maxLength: maxLength,
      hasFourLetters: hasFourLetters,
      hasLowercase: hasLowercase,
      hasUppercase: hasUppercase,
      hasSpecialChar: hasSpecialChar,
      hasTwoNumbers: hasTwoNumbers,
      noSequentialChars: noSequentialChars,
      noForbiddenKeywords: noForbiddenKeywords,
      noRepeatingChars: noRepeatingChars,
      notStartWithNumber: notStartWithNumber,
      notEndWithNumber: notEndWithNumber,
      noSpecialChars:noSpecialChars
    });
  };
  const [isTyped, setIsTyped] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [endpointAccounts, setEndpointAccounts] = useState([]);

  const [powdHints, setPowdHints] = useState({
    minLength: false,
    maxLength:false,
    hasLowercase: false,
    hasUppercase: false,
    hasSpecialChar: false,
    hasTwoNumbers: false,
    hasFourLetters: false,
    noSequentialChars: true,
    noForbiddenKeywords: true,
    noRepeatingChars: true,
    notStartWithNumber: true,
    notEndWithNumber: true,
    noSpecialChars : hasPBC ? true :false
  });
  
const passwordChangeDevices = [
   { name: 'Mobile devices', icon: 'devices_other' },
   { name: 'Mobile device apps', icon: 'apps' },
   { name: 'Email account', icon: 'mail' },
   { name: 'GPWLAN', icon: 'lan' },
  ];
  

  const onSubmit = (data) => {
    const powdError = powdValidation(data.password);
    if (powdError !== true) {
      setError("password", {
        type: "manual",
        message: powdError,
      });
      return;
    }
    updatePassword(data);
  };
  const powdValidation = (password) => {
    // Regex pattern for the MUST requirements
    let pattern;
    if (!hasPBC) {
      pattern = /^(?!.*(.)\1{2})(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*\d)(?=.*[!^*()_|~`{}.#\[\]:;'"<>?,])(?=.{12,24}$)(?!^\d)(?!.*\d$)/;
    } else {
      pattern = /^(?!.*(.)\1{2})(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*\d)(?!.*[^a-zA-Z0-9])(?=.{12,24}$)(?!^\d)(?!.*\d$)/;
    }

    // Checking the password against the regex pattern
    if (!pattern.test(password)) {
      return "Password does not meet the basic criteria.";
    }

    // Additional checks for MUST NOT conditions
    const forbiddenKeywords = [
      "spring",
      "summer",
      "fall",
      "winter",
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
      "PepsiCo",
      "Pepsi",
    ];

    // Check for forbidden keywords
    for (const keyword of forbiddenKeywords) {
      if (password.toLowerCase().includes(keyword.toLowerCase())) {
        return `Password must not contain forbidden keywords like ${keyword}`;
      }
    }

    // Check for sequential characters (abc, 123, etc.)
    const isSequential = (str) => {
      for (let i = 0; i < str.length - 2; i++) {
        if (
          str.charCodeAt(i + 1) === str.charCodeAt(i) + 1 &&
          str.charCodeAt(i + 2) === str.charCodeAt(i) + 2
        ) {
          return true;
        }
      }
      return false;
    };

    if (isSequential(password)) {
      return "Password must not contain sequential characters or numbers.";
    }

    return true; // Password is valid
  };
  const getHintColor = (conditionMet) => {
    // If user hasn't typed yet, default to gray, otherwise red or green based on condition
    return isTyped ? (conditionMet ? "green" : "red") : "#9e9e9e";
  };
  const hasMustHints = (
    getHintColor(powdHints.minLength && powdHints.maxLength && powdHints.hasTwoNumbers && powdHints.hasFourLetters) !== 'green' ||
    getHintColor(powdHints.hasLowercase) !== 'green' ||
    getHintColor(powdHints.hasUppercase) !== 'green' ||
    (!hasPBC && getHintColor(powdHints.hasSpecialChar) !== 'green')
  );
  
  const hasMustNotHints = (
    getHintColor(powdHints.noRepeatingChars) !== 'green' ||
    getHintColor(powdHints.notStartWithNumber) !== 'green' ||
    getHintColor(powdHints.notEndWithNumber) !== 'green' ||
    getHintColor(powdHints.noSequentialChars) !== 'green' ||
    (hasPBC && getHintColor(powdHints.noSpecialChars) !== 'green') ||
    getHintColor(powdHints.noForbiddenKeywords) !== 'green'
  );
  const setVerificationMethod = () => {
    // setForgotPwdOptionType(false);
    // setSelectedOtp(false);
    // setSelectedSecurityQuestion(false);
    // setPasswordSuccess(false);
  };
  const navigate = useNavigate(); // Initialize the navigation hook
  const handleLoginClick = () => {
    navigate("/login"); // Redirect to /login
  };
  
  const intervalRef = useRef(null);
  const attemptsRef = useRef(0);
  const maxAttempts = 9;

  const callApi = async () => {
    try {
      const response = await axios
      .post(REACT_APP_API_ENDPOINT + "auditRequest/getAuditRequest", {
        requestNumber:requestNumber,
        "isPassword":"true"
      })
      const conditionMet = response?.data?.auditInfoData[0]?.request_status === 'Complete';
      const conditionFailed = response?.data?.auditInfoData[0]?.request_status === 'Failed';
      if (conditionMet || attemptsRef.current >= maxAttempts) {
        clearInterval(intervalRef.current);
        console.log('Stopped polling');
        setpowdSuccess(false);
        setpowdSuccessTime(true);
      }
      if(conditionFailed){
        const error_message = "We're currently experiencing an issue with updating the password. Please try again later."
        // showToast(error_message,'error');
        toast.error(error_message);
        navigate('/change-password');
        setpowdSuccess(false);
        setpowdSuccessTime(false);
        setUpdatePassword(true);
        clearInterval(intervalRef.current);
      }

      attemptsRef.current += 1;
    } catch (error) {
      console.error('API call failed:', error);
      clearInterval(intervalRef.current);
    }
  };

  
  // const handleToggle = () => {
  //   setShowPassword((prev) => !prev);
  // };

  const validatePassword = (value) => {
    const errors = [];
    setGpidErrorMessage('');
    if (value?.length < 12) {
      errors.push(t('changePassword.hint_text1'));
    }
    if(!((value?.match(/\d/g)?.length >= 2))){
      errors.push(t('changePassword.hint_text1'));
    }
    if (!/[a-z]/.test(value)) {
      errors.push(t('changePassword.hint_text_2'));
    }
    if (!/[A-Z]/.test(value)) {
      errors.push(t('changePassword.hint_text_3'));
    }
    if(!hasPBC){
      if (!/[!^*()_|~`{}.#[\]:";'<>?,]/.test(value)) {
        errors.push(t('changePassword.hint_text_4'));
      }
    }
    if (/(.)\1{2,}/.test(value)) {
      errors.push(t('changePassword.hint_text_6'));
    }
    if (/^\d/.test(value)) {
      errors.push(t('changePassword.hint_text_8'));
    }
    if (/\d$/.test(value)) {
      errors.push(t('changePassword.hint_text_9'));
    }
    if (/012|123|234|345|456|567|678|789/.test(value)) {
      errors.push(t('changePassword.hint_text10'));
    }
    if(hasPBC){
      if (!/^[a-zA-Z0-9]*$/.test(value)) {
        errors.push(t('changePassword.hint_text_pbc'));
      }
    }
    //NO FORBIDDEN KEYWORDS (NEW)
    const hasForbiddenKeyword = (forbiddenKeywords ?? [])
      .map(k => String(k ?? "").trim().toLowerCase())
      .filter(Boolean)
      .some(k => value.toLowerCase().includes(k));

    if (hasForbiddenKeyword) {
      errors.push(t("changePassword.hint_text12")); // ← forbidden keyword message
    }


  
    setValidPassword(errors.length === 0);
  };
  
  

 
  useEffect(() => {
    if (triggerApi && requestNumber) {
      // Clear any existing interval before starting a new one
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
  
      attemptsRef.current = 0;
      intervalRef.current = setInterval(callApi, 60000); // Poll every 60 seconds
    }
  
    // Cleanup on unmount or when dependencies change
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [triggerApi, requestNumber]);  

  const getEndpointAccounts = () => {
    // setGpidErrorMessage('');
    // axios
    //   .post(REACT_APP_API_ENDPOINT + "/auditRequest/getAuditRequest", {
    //     requestNumber:"6966527",
    //   })
    //   .then((data) => {
    //     console.log(data?.data?.auditInfoData[0]?.request_status);
    //   })
    axios
      .post(REACT_APP_API_ENDPOINT + "/user/getEndpointAccount", {
        gpid: userGpId,
      })
      // .then(response => response.json())
      .then((data) => {
        showLoader();
        if (data.data.status === "Failed") {
          // showToast(data?.data?.errorMessage,'error');
          toast.error(data?.data?.errorMessage);
        }
        let endpointArray = data?.data?.endpointAccounts;
        setEndpointAccounts(endpointArray);
        setHasPBC(data?.data?.pepPasswordPolicy?.toLowerCase() === 'exception');
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        console.error("Error fetching data:", error);
        // showToast(error?.response?.data?.message,'error');
        toast.error(error?.response?.data?.message);
        setGpidErrorMessage(error?.response?.data?.message);
        return {
          gpid: "xxxx",
          secQuestions: [
            "What was your xxx?",
            "What was your xxx?",
          ],
          mobile: "xxxxx",
        };
      });
  };

  const isArabic = userLang.startsWith('ar');

  const setChangeBg = (value) => {
    if (value === true) {
      setIsBg(true);
    } else {
      setIsBg(false);
    }
  };

  const checkPasswordStrength = () => {
    let strength = t("changePassword.weak");
    const pasHintsObj = {...powdHints};
    if(!hasPBC) delete pasHintsObj.noSpecialChars;
    const score = Object.values(pasHintsObj).reduce((s,c)=> c ? s+1 :s ,0);
    if(score > 11) strength = t("changePassword.strong");
    else if(score > 9) strength = t("changePassword.moderate");

    const maxScore = Object.values(pasHintsObj).length;
    return {strength, score, maxScore};
  }

  const strengthColor = {
    [t("changePassword.weak")]: 'red',
    [t("changePassword.moderate")]: 'orange',
    [t("changePassword.strong")]: 'green'
  };

  const {strength, score, maxScore} = checkPasswordStrength();

  const passwordClearBtnRef = useRef();
  const newPasswordClearBtnRef = useRef();

  const passwordClearClick = () => {
    console.log("passwordClearClick")
    setPasswordValue("")
  }

  const hasBothValues =
    password?.length > 0 && newPassword?.length


  const newPasswordClearClick = () => {
    setValue("newPassword", "", { shouldValidate: true });
    clearErrors("newPassword");
    trigger("newPassword");
  }

  useEffect(() => {
    passwordClearBtnRef.current = document.querySelector(".change-new-password-input .clear-button")
    passwordClearBtnRef.current?.addEventListener?.('click', passwordClearClick);

    return () => passwordClearBtnRef.current?.removeEventListener?.('click', passwordClearClick);
  }, [passwordValue]);

  useEffect(() => {
    const clearButtons = document.querySelectorAll(".change-new-password-input .clear-button");
    if (clearButtons.length > 1) {
      newPasswordClearBtnRef.current = clearButtons[1];
      newPasswordClearBtnRef.current?.addEventListener?.('click', newPasswordClearClick);
    }

    return () => newPasswordClearBtnRef.current?.removeEventListener?.('click', newPasswordClearClick);
  }, [newPassword]);

  return (
    <>
      {!showErrorPage ? (
    <div id="change_password_container">
      {/* <h5 className="ml-3">Hello {userName}! </h5>
      <div className={isBg ? "pep_forgot_logo_background" : ""}></div> */}
      {isUpdatePassword && (
        <>
        
        <div
          className={isMobile ? 'row mt-2' : 'container mt-2'}
          style={{
            background: 'none',
            boxShadow: 'none',
            justifyContent: isMobile ? 'center' : '',
            width: isMobile ? '100%' : '60%',
            alignItems:isMobile? 'center' :'none',
            textAlign:isMobile? 'center' :'',
          }}
        >
          <div>
          <div className="d-flex mb-0" style={{alignContent:"center", gap: "1rem"}}>
            <div style={{alignContent:"center"}}>
            <ButtonIcon
              className=""
              color="Interaction/Active"
              icon="vpn_key"
              label="Label"
              onClick={function wRe(){}}
              size="large"
              style={{}}
              type="default"
            />
            </div>
            <div>
              <h5 className="mb-0" style={{fontSize:"20px"}}>
                {t('changePassword.change_password')}
              </h5>
              <p style={{fontSize:"14px"}} className="">{t('changePassword.update_credentials')}</p>
              </div>
            </div>
            <div className={isBg ? "pep_forgot_logo_background" : ""}></div>
            <div style={{
              display: isIpad?'':'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '0px' : '8px',
              flexWrap: 'wrap',
              flex: 1,
              marginTop:"-15px"
            }}>
            {/* Left Section */}
            <div
              className="card card-layout reg-card mb-3 mb-md-0"
              style={{
                marginTop:"0px !important",
                flex: isMobile ? 'unset' : '0 0 calc(50% - 7.5px)',
                width: isMobile ? '100%' : 'auto',
                height:"fit-content"
              }}
            >
              <div className="card-content" style={{padding:"24px !important"}}>
                {/* <h3 style={{fontSize:"18px",display:"flex",alignItems:"flex-start !important"}}>{t('changePassword.create_new_password')}</h3> */}
                {/* <hr className="custom-hr" style={{ marginTop: '0px', marginBottom: '8px' }} /> */}
                
                <form className="form-size pb-3" onSubmit={handleSubmit(onSubmit)}>
                  <div style={{ display: "flex" }}  className="change-new-password-input">
                    <TextInput
                      type={type || ''}
                      value={this}
                      maxLength={24}
                      {...register("password", {
                        required: t("changePassword.password_required"),
                      })}
                      placeholderText={t('changePassword.create_strong_password')}
                      required
                      isPassword={false}
                      label={t("changePassword.new_password")}
                      style={{ width: "-webkit-fill-available", borderColor:gpidErrorMessage ? 'red':''}}
                      // isPassword={true}
                    onChange={(e) => {
                      powdMessageValidation(e.target.value);
                      validatePassword(e.target.value);
                      trigger();
                    }}
                    onPaste={(e)=>e.preventDefault()}
                    className="input-margin-top-bottom-0"
                  />
                  <div
                    className="flex justify-around items-center "
                    id="hide-icon"
                    onClick={handleToggle}
                  >
                    <Icon
                        alt="alt value"
                        icon={icon}
                        size="18px"
                        style={{ marginTop: "22px",marginRight:isArabic?"-32px":"", marginLeft:isArabic? "":"-31px", zIndex:1,fontSize:'21px' }}
                      />
                    
                  </div>
                </div>
                {passwordValue.length > 0 ? <div>
                  <div className="strength-bar ml-2 mt-2">
                    <div className="strength-fill" style={{width: `${(score / maxScore) * 100}%`, backgroundColor: strengthColor[strength]}} />
                  </div>
                  <div className="strength-label d-flex ml-2">
                    <strong style={{color: strengthColor[strength]}}>{strength}</strong>
                  </div>
                </div> : null}
                {/* {errors.password && <div className="fieldError">{errors.password.message}</div>} */}
              <div>
              <div style={{ display: "flex" }}  className="change-new-password-input">
              <TextInput
                type={reType}
                className="mt-1 input-margin-top-bottom-0"
                maxLength={24}
                value={this}
                isPassword={false}
                {...register("newPassword", {
                  // required: t('changePassword.retype_password_required'),
                  validate: (value) =>
                    value === passwordValue || t('changePassword.password_not_match'),
                  onChange: () => { setHasApiError(false); setGpidErrorMessage(''); }
                })}
                style={{width: "-webkit-fill-available",textAlign:isArabic ? "Right" : "left",borderColor:gpidErrorMessage ? 'red':''}}
                helperText={
                  errors.newPassword?.message ||
                  gpidErrorMessage ||
                  (hasBothValues && !validpassword
                    ? 'Password does not meet the required guidelines.'
                    : '')
                }
                required
                placeholderText={t('changePassword.retype_strong_password')}
                label={t("changePassword.retype_password")}
                onPaste={(e)=>e.preventDefault()}
              />
              <div
                className="flex justify-around items-center "
                id="hide-icon"
                onClick={handleToggleRetypePassword}
              >
              <Icon
                  alt="alt value"
                  icon={reTypeIcon}
                  size="18px"
                  style={{ marginTop: "25px",marginRight:isArabic?"-32px":"", marginLeft:isArabic? "":"-31px", zIndex:1,fontSize:'21px' }}
              />
               
              </div>
              </div>
              </div>
                {showGuidelines && !validpassword &&(
                <div className="passwordGuidelines">
                  <div className="passGuides">
                  {(hasMustHints || hasMustNotHints) &&
                    <h5 style={{fontSize:'1rem'}}>{t('changePassword.password_guidelines')}</h5>
                  }
                    
                    {hasMustHints && ( 
                    <h5 style={{fontSize:'1rem'}} className="mb-0 d-flex">
                      {t('changePassword.must')}:</h5>
                    )}
                    {getHintColor(
                      powdHints.minLength &&
                      powdHints.maxLength &&
                      powdHints.hasTwoNumbers &&
                      powdHints.hasFourLetters
                    ) !== 'green' && (
                    <li
                      className="hintText no-select"
                      style={{
                        color: getHintColor(
                          powdHints.minLength &&
                          powdHints.maxLength &&
                          powdHints.hasTwoNumbers &&
                          powdHints.hasFourLetters
                        ),
                      }}                   
                      onCopy={(e) => e.preventDefault()}

                    >
                      <Icon
                        alt="alt value"
                        icon={getHintColor(powdHints.minLength &&
                          powdHints.maxLength &&
                          powdHints.hasTwoNumbers &&
                          powdHints.hasFourLetters) == "red" ? "close" :"check_circle"}
                        size="small"
                        style={{alignItems:'center'}}
                      />{t('changePassword.hint_text1')}
                    </li>
                    )}
                    {getHintColor(powdHints.hasLowercase) !== 'green' && (
                    <li
                      className="hintText no-select"
                      style={{ color: getHintColor(powdHints.hasLowercase) }}
                      onCopy={(e) => e.preventDefault()}
                    >
                      <Icon
                        alt="alt value"
                        icon={getHintColor(powdHints.hasLowercase) == "red" ? "close" :"check_circle"}
                        size="small"
                        style={{alignItems:'center'}}
                      />{t('changePassword.hint_text_2')}
                      
                    </li>
                    )}
                    {getHintColor(powdHints.hasUppercase) !== 'green' && (
                    <li
                      className="hintText no-select"
                      style={{ color: getHintColor(powdHints.hasUppercase) }}
                      onCopy={(e) => e.preventDefault()}
                    >
                      <Icon
                        alt="alt value"
                        icon={getHintColor(powdHints.hasUppercase) == "red" ? "close" :"check_circle"}
                        size="small"
                        style={{alignItems:'center'}}
                      />{t('changePassword.hint_text_3')}
                      
                    </li>
                    )}
                    {!hasPBC && getHintColor(powdHints.hasSpecialChar) !== 'green' && (
                    <li
                      className="hintText no-select"
                      style={{ color: getHintColor(powdHints.hasSpecialChar) }}
                      onCopy={(e) => e.preventDefault()}
                    >
                      <Icon
                        alt="alt value"
                        icon={getHintColor(powdHints.hasSpecialChar) == "red" ? "close" :"check_circle"}
                        size="small"
                        style={{alignItems:'center'}}
                      />{t('changePassword.hint_text_4')} !^*()_|~`{'{}'}.#[]:";'&lt; &gt;?,
                    </li>
                    )}
                    {powdHints &&
                    hasMustNotHints && (
                      <h5 style={{ fontSize: '1rem' }} className="mb-1 mt-1 d-flex">
                       {t('changePassword.must_not')}
                      </h5>
                    )}
                    
                  {getHintColor(powdHints.noRepeatingChars) !== 'green' && (
                  <li
                    className="hintText no-select"
                    style={{
                      color: getHintColor(powdHints.noRepeatingChars),
                    }}
                    onCopy={(e) => e.preventDefault()}
                  >
                    <Icon
                      alt="alt value"
                      icon={getHintColor(powdHints.noRepeatingChars) == "red" ? "close" :"check_circle"}
                      size="small"
                      style={{alignItems:'center'}}
                    />{t('changePassword.hint_text_6')}
                    
                  </li>
                  )}
                  
                  {getHintColor(powdHints.notStartWithNumber) !== 'green' && (
                  <li
                    className="hintText no-select"
                    style={{
                      color: getHintColor(powdHints.notStartWithNumber),
                    }}
                    onCopy={(e) => e.preventDefault()}
                  >
                    <Icon
                      alt="alt value"
                      icon={getHintColor(powdHints.notStartWithNumber) == "red" ? "close" :"check_circle"}
                      size="small"
                      style={{ alignItems: 'center' }}
                    />
                    {t('changePassword.hint_text_8')}
                  </li>
                  )}
                  {getHintColor(powdHints.notEndWithNumber) !== 'green' && (
                    <li
                      className="hintText no-select"
                      style={{
                        color: getHintColor(powdHints.notEndWithNumber),
                      }}
                      onCopy={(e) => e.preventDefault()}
                    >
                      <Icon
                        alt="alt value"
                        icon={getHintColor(powdHints.notEndWithNumber) == "red" ? "close" :"check_circle"}
                        size="small"
                        style={{alignItems:'center'}}
                      />{t('changePassword.hint_text_9')}
                      
                    </li>
                  )}
                  {getHintColor(powdHints.noSequentialChars) !== 'green' && (
                    <li
                      className="hintText no-select"
                      style={{
                        color: getHintColor(powdHints.noSequentialChars),
                      }}
                      onCopy={(e) => e.preventDefault()}
                    >
                      <Icon
                        alt="alt value"
                        icon={getHintColor(powdHints.noSequentialChars) == "red" ? "close" :"check_circle"}
                        size="small"
                        style={{alignItems:'center'}}
                      />{t('changePassword.hint_text10')}
                      
                    </li>
                  )}
                  {hasPBC && getHintColor(powdHints.noSpecialChars) !== 'green' && (
                    <li
                      className="hintText no-select"
                      style={{
                        color: getHintColor(powdHints.noSpecialChars),
                      }}
                      onCopy={(e) => e.preventDefault()}
                    >
                      <Icon
                        alt="alt value"
                        icon={getHintColor(powdHints.noSpecialChars) == "red" ? "close" :"check_circle"}
                        size="small"
                        style={{alignItems:'center'}}
                      />{t('changePassword.hint_text_pbc')}
                      
                    </li>
                  )}
                  {getHintColor(powdHints.noForbiddenKeywords) !== 'green' && (
                    <li
                      className="hintText no-select mb-2"
                      style={{
                        color: getHintColor(powdHints.noForbiddenKeywords),
                      }}
                      onCopy={(e) => e.preventDefault()}
                    >
                      <Icon
                        alt="alt value"
                        icon={getHintColor(powdHints.noForbiddenKeywords) == "red" ? "close" :"check_circle"}
                        size="small"
                        style={{alignItems:'center'}}
                      />{t('changePassword.hint_text12')}
                      
                    </li>
                  )}
                  
                  {(
                    getHintColor(powdHints.noRepeatingChars) !== 'green' ||
                    getHintColor(powdHints.notStartWithNumber) !== 'green' ||
                    getHintColor(powdHints.notEndWithNumber) !== 'green' ||
                    getHintColor(powdHints.noSequentialChars) !== 'green' ||
                    (hasPBC && getHintColor(powdHints.noSpecialChars) !== 'green') ||
                    getHintColor(powdHints.noForbiddenKeywords) !== 'green'
                  ) && (
                  <li className="hintText no-select d-flex" onCopy={(e) => e.preventDefault()}>
                  <Icon
                      alt="alt value"
                      icon="info_outline"
                      size="small"
                      style={{width:"15px"}}
                    />{t('changePassword.hint_text_5')}
                    
                  </li>
                  )}
                  {(
                    getHintColor(powdHints.noRepeatingChars) !== 'green' ||
                    getHintColor(powdHints.notStartWithNumber) !== 'green' ||
                    getHintColor(powdHints.notEndWithNumber) !== 'green' ||
                    getHintColor(powdHints.noSequentialChars) !== 'green' ||
                    (hasPBC && getHintColor(powdHints.noSpecialChars) !== 'green') ||
                    getHintColor(powdHints.noForbiddenKeywords) !== 'green'
                  ) && (
                  <li className="hintText no-select" onCopy={(e) => e.preventDefault()}>
                  <Icon
                      alt="alt value"
                      icon="info_outline"
                      size="small"
                      style={{width:"15px"}}
                    />
                    {t('changePassword.hint_text_7')}
                    
                  </li>
                  )}
                  {(
                    getHintColor(powdHints.noRepeatingChars) !== 'green' ||
                    getHintColor(powdHints.notStartWithNumber) !== 'green' ||
                    getHintColor(powdHints.notEndWithNumber) !== 'green' ||
                    getHintColor(powdHints.noSequentialChars) !== 'green' ||
                    (hasPBC && getHintColor(powdHints.noSpecialChars) !== 'green') ||
                    getHintColor(powdHints.noForbiddenKeywords) !== 'green'
                  ) && (
                  <li className="hintText no-select" onCopy={(e) => e.preventDefault()}>
                    <Icon
                      alt="alt value"
                      icon="info_outline"
                      size="small"
                      style={{width:"15px"}}
                    />{t('changePassword.hint_text11')}
                      
                    </li>
                  )}
                  
                  </div>
                </div>
                )}
                
                { isValid &&
                  hasInput &&
                  validpassword &&
                  newPassword.length > 0 &&
                  password !== newPassword && (

                  <div className="passwordSuccess mt-2">
                    <Icon
                      alt="alt value"
                      icon="check_circle"
                      size="small"
                      className="pr-1 align-items-center"
                      style={{ color: "#166A15" }}
                    />
                    <div>
                      <div className="passwordSuccessHeading" style={{ justifySelf: "flex-start" }}>
                        {t("changePassword.ready_to_go")}
                      </div>
                      <div className="passwordSuccessParagraph">
                        {t("changePassword.password_meet_requirements")}.
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-2">
                  <Checkbox
                    label=""
                    size="small"
                    checked ={isConfirmed}
                    className="d-flex justify-content-start"
                    onUpdate={(event) => {
                      onConfirmation(event);
                    }}
                    text={
                      <>
                      <span>
                      {t('changePassword.terms_check')}{" "}
                        <a href="https://myidm.mypepsico.com/iam/im/pepsicopub/page/jsp/legalTermsConditions.jsp" target="_blank" rel="noreferrer">
                          {t('footer_terms')}
                        </a>
                      </span>
                        
                      </>
                    }
                  />
                </div>
                {/* <br /><br /> */}
                <div className="d-flex justify-content-end align-items-end" style={{gap:"16px"}}>
                <Button
                  type="button"
                  onClick={()=>goToHomePage()}
                  size="medium"
                  variant="secondary"
                  className="mt-4"
                  // disabled={!validpassword || !isValid || !isConfirmed }
                >
                  {t('changePassword.cancel')}
                </Button>
                <Button
                  type="submit"
                  size="medium"
                  className="mt-4"
                  disabled={!validpassword || !isValid || !isConfirmed || hasApiError}
                >
                  {t('changePassword.change_password')}
                </Button>
                </div>
                {/* {gpidErrorMessage && (
                  <div className="fieldError">{gpidErrorMessage}</div>
                )} */}
              </form>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="reg-card mb-0"
              style={{
                flex: isMobile ? 'unset' : '0 0 calc(50% - 7.5px)',
                width: isMobile ? '100%' : 'auto',
                marginTop: isMobile ? '5px' : '15px !important',
                padding:isIpad || isMobile? '':'0.5rem'
              }}
            >
              <div className="changePasswordEndPoints" style={{marginTop:"10px"}}>
                <div className="changePasswordEndPointsHeadingLayout">
                <div className="changePasswordEndPointsHeading" style={{justifySelf:"center"}}>
                <ButtonIcon
                  className=""
                  color="Interaction/Active"
                  icon="apps"
                  label="Label"
                  onClick={function wRe(){}}
                  size="medium"
                  style={{borderRadius: "var(--Semantic-Corner-Radius-Action-Medium, 4px)",
                    background: "var(--Semantic-Neutrals-Blue-Low, #F5F9FF)"}}
                  type="naked"
                />
                <div className="ml-2">
                  {t('changePassword.systems')}
                </div>  
                  </div>
                </div>
                <div className="changePasswordEndPointsparagraphs">{t('changePassword.system_change_text')}</div>
                <div className="accountsAlign">
                  {endpointAccounts?.map((point, index) => (
                    <span key={index} className="endPointInfo">{point}{" "}</span>
                  ))}
                </div>
              </div>
              <div className="mt-2">
              <AccordionItemV2
              
              className=""
              expanded
              icon="contact_support"
              imageUrl=""
              label={t('changePassword.having_trouble_text')}
              onUpdate={function wRe(){}}
              presentation="box-shadow"
              style={{color:"red"}}
              subTitle=""
            >
            <div className="havingTroubleSection" >
                <div className="havingTroubleSectionHeading d-flex">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mr-1"
                  icon="support_agent"
                  size="medium"
                  style={{}}
                />  
                  {t('changePassword.help_text')}
                </div>
                <div className="havingTroubleSectionParagraph mt-1 ml-4">
                  {t('changePassword.help_text_para')}
                {/* <div className="d-flex supportContact">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mt-1 mr-1"
                  icon="mail"
                  size="small"
                  style={{color:"var(--Semantic-Interaction-Primary, #004895)"}}
                />
                  itsupport@pepsico.com
                </div> */}
                <a href="https://www.mypepsico.com/mypepsico?id=help_desk_numbers" target="_blank">
                <div className="d-flex supportContact">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mt-1 mr-1"
                  icon="call"
                  size="small"
                  style={{color:"var(--Semantic-Interaction-Primary, #004895)"}}
                />
                  Global Help Desk Number
                </div>
                </a>
                </div>
              </div>
            
            {/* <div className="havingTroubleSection" >
                <div className="havingTroubleSectionHeading d-flex">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mr-1"
                  icon="flag"
                  size="medium"
                  style={{}}
                />  
                  {t('changePassword.raise_ticket')}
                  
                </div>
                <div className="havingTroubleSectionParagraph mt-1 ml-4">
                {t('changePassword.submit')}
                <a href="https://pepsico.service-now.com/mypepsico?id=sc_cat_item&table=sc_cat_item&sys_id=a185d79b93fa62101a0eb0fdfaba10c3&searchTerm=myidm%20operations%20service%20request" target="_blank">
                {t('changePassword.rasie_support_link')}
                </a>
                {t('changePassword.raise_support_text')}
                
                </div>
            </div> */}
              
              
            </AccordionItemV2>
              </div>
              
              {/* <div className="con-layout pl-1 pr-1">
                <hr className="custom-hr mb-0 mt-0" />
                <img src={no_vpn_logo} alt="" width="17%" className="pb-8" />
                <p className="not-con-head" style={{ marginBottom: '0px', paddingBottom: '0px' }}>
                  {t('changePassword.not-network')}
                </p>
                <p className="not-con-para mb-0 pb-0 fs-12">
                  {t('changePassword.not-net-desc')}
                </p>
                <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'right' }}>
                  <Button
                    className=""
                    iconTrailing="arrow_right_alt"
                    size="small"
                    style={{ fontSize: '11px' }}
                    text="See details"
                    variant="tertiary"
                    onClick={updateModalStatusNonPepsico}
                  />
                </div>
              </div>

              <div className="con-layout pl-1 pr-1">
                <hr className="custom-hr mb-0 mt-0" />
                <img src={vpn_logo} alt="" width="17%" className="pb-16" />
                <p className="not-con-head mb-0 pb-0" style={{ marginBottom: '0px', paddingBottom: '0px' }}>
                 {t('changePassword.vpn-head')}
                </p>
                <p className="not-con-para mb-0 pb-0">
                  {t('changePassword.vpn-des')}
                </p>
                <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'right' }}>
                  <Button
                    className=""
                    iconTrailing="arrow_right_alt"
                    size="small"
                    style={{ fontSize: '11px' }}
                    text="See details"
                    variant="tertiary"
                    onClick={updateModalStatus}
                  />
                </div>
              </div> */}
            </div>
            </div>
          </div>
        </div>
        </>
      )}
      {powdSuccess && (
        <div>
          
          <div className="card mb-3">
          <Notification
            className=""
            primaryActionLabel="Pepsico's WiFi/VPN"
            primaryActionOnClick={updateModalStatus}
            secondaryActionLabel="Out of network"
            secondaryActionOnClick={updateModalStatusNonPepsico}
            showActionButtons
            showIcon
            showText
            showTitle
            style={{}}
            text={t('changePassword.pepsico_vpn_not_text')}
            title={t('changePassword.pepsico_vpn_not_heading')}
            type="warning"
          />
          </div>
          <div className="card card-layout reg-card">
            <div className="card-content mb-3" style={{alignItems:'center'}}>
              {/* <div>
                <img src={pepsi_logo} alt="" style={{width:'60%'}}/>
              </div> */}
              <div className="info-container">
                <p>{t('changePassword.updating_password')}</p>
              </div>
              <hr className="custom-hr" style={{marginTop:'0px',marginBottom:'8px'}}/>
              <p className="text-cpr">{t('changePassword.password_sync_time')}</p>
              <ProgressBar
                className=""
                endLabel=""
                label={`About ${(timeLeft/ 60).toFixed(0)} min remaining`}
                max={totalTime}
                size="medium"
                startLabel=""
                status="active"
                style={{}}
                value={timeLeft}
                variant="determinate"
              />
              <div className="powd_timer_background"></div>
              {/* <div className="accountsAlign">
                {endpointAccounts?.map((point, index) => (
                  <span key={index} className="endPointInfoSuccess">
                    {point}{" "} 
                  </span>
                ))}
              </div> */}
              <hr className="custom-hr" />
              <div>
                {/* <Button
                  className="full-button"
                  size="medium"
                  onClick={handleLoginClick}
                >
                  Refresh 
                </Button> */}
              </div>
              {/* <ForgotFooter /> */}
            </div>
          </div>
          
        </div>
      )}
      <ToastContainer position="bottom-center" data={toasts} removeToast={removeToast} />
      <div>
        
        <Modal
          auxiliaryButtonProps={null}
          className=""
          closeOnOutsideClick
          linkProps={null}
          notificationsProps={null}
          showModal={updateStatus}
          onCloseModal={closeModal}
          primaryButtonProps={{
            onClick: () => {setUpdateStatus(false)},
            size: 'medium',
            text: 'Accept',
            variant: 'primary'
          }}
          secondaryButtonProps={null}
          showAuxiliaryButton
          showLink
          showPrimaryButton
          style={{}}
          tertiaryButtonProps={null}
          text={t('changePassword.pepsico_non_network_text')}
          title={t('changePassword.pepsico_non_network_heading')}
          type="fluid"
          viewPort={isMobile?"mobile":'desktop'}
        >
        </Modal>
      </div>

      <div>
          <Modal
            auxiliaryButtonProps={null}
            className=""
            closeOnOutsideClick
            footerProps={null}
            linkProps={null}
            notificationsProps={{
              primaryActionLabel: buttonName,
              primaryActionOnClick: function handleCopy(){
                try {
                  navigator.clipboard.writeText(textToCopy);
                  setCopied(true);
                  setButtonName('Copied');
                  setTimeout(() =>{ 
                    setCopied(false)
                    setButtonName('Copy');
                  }, 2000); // Reset after 2 seconds
                  } catch (err) {
                  console.error("Failed to copy: ", err);
                }
              },
              secondaryActionOnClick: function Xs(){},
              text:t('changePassword.pepsico_network_text'),
              type: 'info'
            }}
            showModal={updateStatusNonPepsico}
            onCloseModal={closeModalNonPepsico}
            primaryButtonProps={null}
            secondaryButtonProps={null}
            showTertiaryButton
            style={{}}
            tertiaryButtonProps={null}
            text={t('changePassword.pepsico_network_text_1')}
            title={t('changePassword.pepsico_network_heading')}
            type="fluid"
            viewPort={isMobile?"mobile":'desktop'}
          >
          </Modal>
        </div>
      {/* <div>
        <Modal
          auxiliaryButtonProps={{
            onClick: function Xs(){},
            size: 'medium',
            text: 'Button',
            variant: 'auxiliary'
          }}
          className=""
          closeOnOutsideClick
          footerProps={null}
          linkProps={null}
          notificationsProps={null}
          showModal={updateStatus}
          onCloseModal={closeModal}
          primaryButtonProps={{
            onClick: function Xs(){},
            size: 'medium',
            text: 'Button',
            variant: 'primary'
          }}
          secondaryButtonProps={{
            onClick: function Xs(){},
            size: 'medium',
            text: 'Button',
            variant: 'secondary'
          }}
          showPrimaryButton
          showSlot
          style={{}}
          tertiaryButtonProps={null}
          text={`Continue to use your old Computer Logon password to lock/unlock your computer. \n 
            When you connect to the PepsiCo network, complete the following password synchronization steps:`}
          title="Instructions for non PepsiCo VPN/WiFi connection"
          type="fluid"
          viewPort="desktop"
        >
          <Slot
            detail={`  1. Press Ctrl+Alt+Delete, and then select Loc Computer or Lock Workstation to lock the computer.\n 
            2. Press Ctrl+Alt+Delete again and type your new password to unlock the computer/workstation. `}
            style={{
              height: '100%',
              width: '100%'
            }}
            title="Slot component"
          />
        </Modal>
      </div> */}
      {powdSuccessTime && (
        <>
        
        <div
          className={isMobile ? 'row mt-2' : 'container mt-2'}
          style={{
            background: 'none',
            boxShadow: 'none',
            justifyContent: isMobile ? 'center' : '',
            width: isMobile ? '100%' : '100%',
            alignItems:isMobile? 'center' :'none',
            textAlign:isMobile? 'center' :'',

          }}
        >
          
          <div>
          {/* <div className="d-flex mb-0" style={{alignContent:"center", gap: "1rem"}}>
            <div style={{alignContent:"center"}}>
            <ButtonIcon
              className=""
              color="Interaction/Active"
              icon="vpn_key"
              label="Label"
              onClick={function wRe(){}}
              size="large"
              style={{}}
              type="default"
            />
            </div>
            <div>
              <h5 className="mb-0" style={{fontSize:"22px"}}>
                {t('changePassword.change_password')}
              </h5>
              <p style={{fontSize:"14px"}} className="">{t('changePassword.update_credentials')}</p>
              </div>
            </div> */}
            <div className={isBg ? "pep_forgot_logo_background" : ""}></div>
            <div style={{
              display: isIpad?'':'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '0px' : '8px',
              flexWrap: 'wrap',
              flex: 1,
              marginTop:"-15px"
            }}>
            {/* Left Section */}
            <div
              className="card card-layout reg-card mb-3 mb-md-0"
              style={{
                marginTop:"0px !important",
                flex: isMobile ? 'unset' : '0 0 calc(60% - 7.5px)',
                width: isMobile ? '100%' : 'auto',
                height:"fit-content"
              }}
            >
              <div className="card-content" style={{padding:"24px !important"}}>

                <div className="passwordSuccessSection">
                  <img src={success_logo} alt="" style={{width:"100px",marginTop:"-12px"}} />
                  <div>
                  <h2 className="successHeading mb-1" style={{textAlign:"left"}}>{t('changePassword.password_update_success')}</h2>
                  <div>
                  <div className="changePasswordEndPointsparagraphs mb-1" style={{textAlign:"left"}}>{t('changePassword.system_change_text')}</div>
                  </div>
                  <div className="accountsAlign">
                  {endpointAccounts?.map((point, index) => (
                    <span key={index} className="endPointInfo">{point}{" "}</span>
                  ))}
                </div>
                  </div>
                </div>
                <div className="syncPasswordTime d-flex">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mr-1"
                  icon="info"
                  size="medium"
                  style={{color:"#0662C4",marginTop:"3px"}}
                />
                <div className="syncPasswordTimePara">{t('changePassword.password_sync_message')} Password <strong>{t('changePassword.upto_10_mins')}</strong> {t('changePassword.after_password_change')}</div>  
                </div>
                <div className="successUpdates">
                  <div className="d-flex" style={{alignItems:'center',gap:"15px"}}>
                  <Icon
                    alt="alt value"
                    className="$color-icon-default"
                    icon="devices"
                    size="medium"
                    style={{color:"#D6AC16"}}
                  />
                  <div>
                  
                  <div className="systemsHeading" style={{justifySelf:"flex-start"}}>
                    {t('changePassword.manual_update')}
                  </div>
                  <div className="systemsParagraph" style={{justifySelf:"flex-start"}}>
                    {t('changePassword.sync_accounts')}
                    {/* {"Don't forget to sync these services"} */}
                  </div>
                  </div>
                  </div>
                  <div className="UpdateSystems" style={{display: isMobile || isIpad ? 'block' : ''}}>
                  <div className="PasswordUpdates" style={{marginBottom: isMobile || isIpad ? '10px' : ''}}>
                  <div className="d-flex" style={{alignItems:'flex-start',gap:"15px"}}>
                  <Icon
                    alt="alt value"
                    className="$color-icon-default"
                    icon="mail"
                    size="medium"
                    style={{}}
                  />
                  <div>
                  <div className="PasswordUpdatesHeading" style={{justifySelf:"flex-start"}}>
                  PepsiCo Email
                  </div>
                  <div className="systemsParagraph" style={{textAlign:"left"}}>
                  {t('changePassword.update_email')}
                  </div>
                  </div>
                  </div>
                  </div>

                  <div className="PasswordUpdates">
                  <div className="d-flex" style={{alignItems:'flex-start',gap:"15px"}}>
                  <Icon
                    alt="alt value"
                    className="$color-icon-default"
                    icon="wifi"
                    size="medium"
                    style={{}}
                  />
                  <div>
                  <div className="PasswordUpdatesHeading" style={{justifySelf:"flex-start"}}>
                  GPWLAN
                  </div>
                  <div className="systemsParagraph" style={{textAlign:"left"}}>
                  {t('changePassword.reconnect_new_cred')}
                  </div>
                  </div>
                  </div>
                  </div>
                  </div>
                  <div className="UpdateSystems" style={{display: isMobile || isIpad ? 'block' : ''}}>
                  <div className="PasswordUpdates" style={{marginBottom: isMobile || isIpad ? '10px' : ''}}>
                  <div className="d-flex" style={{alignItems:'flex-start',gap:"15px"}}>
                  <Icon
                    alt="alt value"
                    className="$color-icon-default"
                    icon="apps"
                    size="medium"
                    style={{}}
                  />
                  <div>
                  <div className="PasswordUpdatesHeading" style={{justifySelf:"flex-start"}}>
                      Mobile Device Apps
                  </div>
                  <div className="systemsParagraph" style={{textAlign:"left"}}>
                  {t('changePassword.update_mobile_app')}
                  </div>
                  </div>
                  </div>
                  </div>

                  <div className="PasswordUpdates">
                  <div className="d-flex" style={{alignItems:'flex-start',gap:"15px"}}>
                  <Icon
                    alt="alt value"
                    className="$color-icon-default"
                    icon="phone_iphone"
                    size="medium"
                    style={{}}
                  />
                  <div>
                  <div className="PasswordUpdatesHeading" style={{justifySelf:"flex-start"}}>
                    Mobile Devices
                  </div>
                  <div className="systemsParagraph" style={{textAlign:"left"}}>
                    {t('changePassword.update_password_message')}
                  </div>
                  </div>
                  </div>
                  </div>
                  </div>
                  <div className="full-button">
                  <Button
                   className="full-button"
                    onClick={()=>{goToHomePage()}}
                    type="button"
                    iconLeading="arrow_back"
                    size="medium"
                    style={{}}
                    text="Back to Home"
                    variant="primary"
                  />  
                  </div>

                </div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="reg-card mb-0"
              style={{
                flex: isMobile ? 'unset' : '0 0 calc(40% - 7.5px)',
                width: isMobile ? '100%' : 'auto',
                marginTop: isMobile ? '5px' : '15px !important',
                padding:isIpad || isMobile? '':'0.25rem'
              }}
            >
              {/* <div className="changePasswordEndPoints" style={{marginTop:"10px"}}>
                <div className="changePasswordEndPointsHeadingLayout">
                <div className="changePasswordEndPointsHeading" style={{justifySelf:"center"}}>
                <ButtonIcon
                  className=""
                  color="Interaction/Active"
                  icon="apps"
                  label="Label"
                  onClick={function wRe(){}}
                  size="medium"
                  style={{borderRadius: "var(--Semantic-Corner-Radius-Action-Medium, 4px)",
                    background: "var(--Semantic-Neutrals-Blue-Low, #F5F9FF)"}}
                  type="naked"
                />
                <div className="ml-2">
                  {t('changePassword.systems')}
                </div>  
                  </div>
                </div>
                <div className="changePasswordEndPointsparagraphs">{t('changePassword.system_change_text')}</div>
                <div className="accountsAlign">
                  {endpointAccounts?.map((point, index) => (
                    <span key={index} className="endPointInfo">{point}{" "}</span>
                  ))}
                </div>
              </div> */}
              {/* <div className="mt-3">
              <AccordionItemV2
              
              className=""
              expanded
              icon="contact_support"
              imageUrl=""
              label={t('changePassword.having_trouble_text')}
              onUpdate={function wRe(){}}
              presentation="box-shadow"
              style={{color:"red"}}
              subTitle=""
            >
            <div className="havingTroubleSection" >
                <div className="havingTroubleSectionHeading d-flex">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mr-1"
                  icon="flag"
                  size="medium"
                  style={{}}
                />  
                  {t('changePassword.raise_support')}
                  
                </div>
                <div className="havingTroubleSectionParagraph mt-1 ml-4">
                {t('changePassword.raise_support_text')}
                <Button
                  className="mt-1"
                  size="small"
                  style={{}}
                  text={t('changePassword.raise_ticket')}
                  variant="secondary"
                />
                </div>
            </div>
            <div className="havingTroubleSection" >
                <div className="havingTroubleSectionHeading d-flex">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mr-1"
                  icon="support_agent"
                  size="medium"
                  style={{}}
                />  
                  {t('changePassword.help_text')}
                </div>
                <div className="havingTroubleSectionParagraph mt-1 ml-4">
                  {t('changePassword.help_text_para')}
                <div className="d-flex supportContact">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mt-1 mr-1"
                  icon="mail"
                  size="small"
                  style={{color:"var(--Semantic-Interaction-Primary, #004895)"}}
                />
                  itsupport@pepsico.com
                </div>
                <div className="d-flex supportContact">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mt-1 mr-1"
                  icon="call"
                  size="small"
                  style={{color:"var(--Semantic-Interaction-Primary, #004895)"}}
                />
                  +1 (800) 555-0199
                </div>
                </div>
              </div>  
              
            </AccordionItemV2>
              </div> */}
              <div className="mt-3">
              <AccordionItemV2
              
              className=""
              expanded={false}
              icon="contact_support"
              imageUrl=""
              label={t('changePassword.having_trouble_text')}
              onUpdate={function wRe(){}}
              presentation="box-shadow"
              style={{color:"red",textAlign:"left"}}
              
            >
            <div className="havingTroubleSection" >
                <div className="havingTroubleSectionHeading d-flex">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mr-1"
                  icon="support_agent"
                  size="medium"
                  style={{}}
                />  
                  {t('changePassword.help_text')}
                </div>
                <div className="havingTroubleSectionParagraph mt-1 ml-4">
                  {t('changePassword.help_text_para')}
                
                <a href="https://www.mypepsico.com/mypepsico?id=help_desk_numbers" target="_blank">
                <div className="d-flex supportContact">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mt-1 mr-1"
                  icon="call"
                  size="small"
                  style={{color:"var(--Semantic-Interaction-Primary, #004895)"}}
                />
                  Global Help Desk Number
                </div>
                </a>
                </div>
            </div>
            
            {/* <div className="havingTroubleSection" >
                <div className="havingTroubleSectionHeading d-flex">
                <Icon
                  alt="alt value"
                  className="$color-icon-default mr-1"
                  icon="flag"
                  size="medium"
                  style={{}}
                />  
                  {t('changePassword.raise_ticket')}
                  
                </div>
                <div className="havingTroubleSectionParagraph mt-1 ml-4">
                {t('changePassword.submit')}
                <a href="https://pepsico.service-now.com/mypepsico?id=sc_cat_item&table=sc_cat_item&sys_id=a185d79b93fa62101a0eb0fdfaba10c3&searchTerm=myidm%20operations%20service%20request" target="_blank">
                {t('changePassword.rasie_support_link')}
                </a>
                {t('changePassword.raise_support_text')}
                
                </div>
            </div> */}
              
              
            </AccordionItemV2>
              </div>

              <div className="mt-2">
              <AccordionItemV2
              
              className=""
              expanded
              icon="network_check"
              imageUrl=""
              label={t('Password Synchronization Steps With Your Workstation')}
              onUpdate={function wRe(){}}
              presentation="box-shadow"
              style={{color:"red",textAlign:"left"}}
              subTitle=""
            >
            <div className="passwordSync" >
                
            <div className="havingTroubleSectionHeading d-flex justify-content-between">
                  <div className="d-flex">
                    <Icon
                      alt="alt value"
                      className="$color-icon-default mr-1"
                      icon="wifi"
                      size="medium"
                    />
                    <span>{t("If you are on PepsiCo Network")}</span>
                  </div>

                  <Icon
                    alt="alt value"
                    className="$color-icon-default"
                    icon={copied ? 'check_circle':'copy'}
                    size="medium"
                    title={copied ? 'copied':'copy'}
                    style={{color:copied? "green":""}}
                    onClick={()=>{copyToClipboard(textToCopy,false)}}
                  />
                  {/* {copied ? 'copied':''} */}
                </div>
                <div className="havingTroubleSectionParagraph mt-1 ml-4">
                
                  <li>{t('changePassword.pepsi_network_text1')}</li>
                  <li>{t('changePassword.pepsi_network_text2')}</li>
                  <li>{t('changePassword.pepsi_network_text3')}</li>
                
                </div>
            </div>
            <div className="passwordSyncNotPepsico" >
            <div className="havingTroubleSectionHeading d-flex justify-content-between" style={{width:"100%"}}>
                  {/* Left side: icon + text */}
                  <div className="d-flex">
                    <Icon
                      alt="alt value"
                      className="$color-icon-default mr-1"
                      icon="wifi_off"
                      size="medium"
                    />
                    <span>{t("If you are NOT on PepsiCo Network")}</span>
                  </div>

                  {/* Right side: copy icon */}
                  <div className="">
                    <Icon
                    alt="alt value"
                    className="$color-icon-default"
                    icon={copiedNonPepsi ? 'check_circle':'copy'}
                    size="medium"
                    title={copiedNonPepsi ? 'copied':'copy'}
                    style={{color:copiedNonPepsi? "green":""}}
                    onClick={() => {copyToClipboard(textToCopyNonPepsi,true)}}
                  />
                  {/* {copiedNonPepsi ? 'copied':''} */}
                  </div>
                </div>

                <div className="havingTroubleSectionParagraph mt-1 ml-4">
                  <li>{t('changePassword.pepsi_non_network_text1')}</li>
                  <li>{t('changePassword.pepsi_non_network_text2')}</li>
                
                </div>
              </div>  
              
            </AccordionItemV2>
              </div>
              
              {/* <div className="con-layout pl-1 pr-1">
                <hr className="custom-hr mb-0 mt-0" />
                <img src={no_vpn_logo} alt="" width="17%" className="pb-8" />
                <p className="not-con-head" style={{ marginBottom: '0px', paddingBottom: '0px' }}>
                  {t('changePassword.not-network')}
                </p>
                <p className="not-con-para mb-0 pb-0 fs-12">
                  {t('changePassword.not-net-desc')}
                </p>
                <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'right' }}>
                  <Button
                    className=""
                    iconTrailing="arrow_right_alt"
                    size="small"
                    style={{ fontSize: '11px' }}
                    text="See details"
                    variant="tertiary"
                    onClick={updateModalStatusNonPepsico}
                  />
                </div>
              </div>

              <div className="con-layout pl-1 pr-1">
                <hr className="custom-hr mb-0 mt-0" />
                <img src={vpn_logo} alt="" width="17%" className="pb-16" />
                <p className="not-con-head mb-0 pb-0" style={{ marginBottom: '0px', paddingBottom: '0px' }}>
                 {t('changePassword.vpn-head')}
                </p>
                <p className="not-con-para mb-0 pb-0">
                  {t('changePassword.vpn-des')}
                </p>
                <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'right' }}>
                  <Button
                    className=""
                    iconTrailing="arrow_right_alt"
                    size="small"
                    style={{ fontSize: '11px' }}
                    text="See details"
                    variant="tertiary"
                    onClick={updateModalStatus}
                  />
                </div>
              </div> */}
            </div>
            </div>
          </div>
        </div>
        </>
      )}
    </div>) : (
        <ErrorFailOverHandler
          header="Something went wrong"
          title="Uh oh, we can’t seem to find the data you’re looking for."
          supportMessage="Try going back or contact"
          supportLabel="Support"
          supportLink="mailto:DL-IAMCentralDevelopment@ips.com"
          alternateMessage="You can also complete tasks in myidM"
          alternateLabel="Go to myIDM"
          alternateLink="https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoChangeMyPassword"
          image="src/assets/error.png"
        />
      )}
    </>
  );
};

export default ChangePassword;
